import styled from "styled-components";

export const StyledMyBookmarks = styled.div`
  overflow-y: auto;
  min-height: 100vh !important;
  padding-bottom: 2rem;
`